import { ClienteBatteria } from "./ClienteBatteria";
import { ClienteSlotDialog } from "./ClienteSlotDialog";

// Un solo controllo per i tre dettagli (Batteria, Casa, Rete): aperti sia dalle bolle sull'immagine sia dalle card sotto
export function SlotDialogs({ slot, onClose, src, soh, temp, pro }) {
  if (!src) return null;
  return (
    <>
      <ClienteBatteria open={slot === "batteria"} onClose={onClose} src={src} soh={soh} temp={temp} pro={pro} />
      <ClienteSlotDialog open={slot === "produzione"} kind="produzione" onClose={onClose} src={src} />
      <ClienteSlotDialog open={slot === "casa"} kind="casa" onClose={onClose} src={src} />
      <ClienteSlotDialog open={slot === "rete"} kind="rete" onClose={onClose} src={src} />
    </>
  );
}
